












import { Component, Prop, Mixins } from "vue-property-decorator";
import { FraudStatus } from "@/data/enums";
import { FraudStatusMap } from "@/data/fraud";
import Context from "@/mixins/context";

@Component
export default class UFraudmindIcon extends Mixins(Context) {
  // Props

  @Prop({ required: true })
  public status!: FraudStatus;

  @Prop({ default: () => [FraudStatus.NOT_FRAUD] })
  public omit!: FraudStatus[];

  @Prop({ default: 18 })
  public size!: number;

  @Prop({ default: "" })
  public type!: string;

  @Prop({ default: true })
  public hasTooltip!: boolean;

  @Prop({ default: "" })
  public tooltipLabel!: string;

  @Prop({ default: "is-right" })
  public tooltipPosition!: string;

  @Prop({ default: false })
  public isDisabled!: boolean;

  // Data

  public FraudStatusMap = FraudStatusMap();

  // Computed
  public get component() {
    if (this.hasTooltip)
      return {
        is: "b-tooltip",
        props: {
          label:
            this.tooltipLabel ||
            this.$t("_sentence.status_with_fraudmind", {
              status: this.fraudStatus.label
            }),
          class: "has-cursor-help",
          position: this.tooltipPosition,
          type: this.fraudStatus.type
        }
      };
    return {
      is: "span"
    };
  }

  public get fraudStatus() {
    return this.$_.get(this.FraudStatusMap, this.status);
  }

  public get svg() {
    return {
      src: "/assets/images/interface/logos/fraudmind.svg#fraudmind",
      class: `${(this.type || this.fraudStatus.type).replace(
        /^is-/,
        `has-text-`
      )}${this.isDisabled ? " is-disabled" : ""}`
    };
  }
}
